import { render, staticRenderFns } from "./ValidationProviderExtended.vue?vue&type=template&id=27035493&"
import script from "./ValidationProviderExtended.vue?vue&type=script&lang=js&"
export * from "./ValidationProviderExtended.vue?vue&type=script&lang=js&"
import style0 from "./ValidationProviderExtended.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports